import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/about/business/pageContext';

export function BusinessErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for About/Business page (error: ${error})`);
}
